import WithRender from "../../templates/imageEditorGalleries/imageEditorUploadedImages.html";
import { mapActions, mapGetters } from "vuex";
import VueUploadComponent from "vue-upload-component";
import * as R from "ramda";
import ImageEditorGallery from "../imageEditorGalleries/ImageEditorGallery";

export default WithRender({
  data() {
    return {
      files: []
    };
  },
  components: {
    "file-upload": VueUploadComponent,
    appImageEditorGallery: ImageEditorGallery
  },
  computed: {
    ...mapGetters({
      POIEVariables: "getPOIEVariables",
      customer: "getCustomer",
      items: "getCustomerImageGalleryItems",
      uploadUserPhotoUrl: "getuploadUserPhotoUrl"
    })
  },
  methods: {
    ...mapActions([
      "loadCustomerGallery",
      "addCustomerImage",
      "emptyCustomerGallery"
    ]),
    inputFile(newFile, oldFile) {
      this.$refs.upload.active = true;
      if (newFile.success) {
        const { success, data } = newFile.response;
        if (success) {
          R.forEach(item => {
            item.uploaded = true;
            this.addCustomerImage(item);
          }, data);
        }
      }
    }
  },
  created() {
    this.loadCustomerGallery();
  },
  watch: {
    customer: function () {
      this.emptyCustomerGallery();
      this.loadCustomerGallery();
    }
  }
});
